import { convertObjToQueryString } from "../../utils/helpers";

export const getCompleteMealPlanForUser = (userId: string | undefined) => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_NUTRITION_API_URL}/load/mealplan/complete`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getRecipeNameFromRecipeIds = (data: { [key: string]: any }) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_NUTRITION_API_URL}/recipe/names/from/ids`,
    data,
  };
};

export const getRecipeCategoryList = () => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_NUTRITION_API_URL}/recipe/category/list`,
  };
};

export const getRecipeListFromSearchedTerm = (queryObj: {
  [key: string]: any;
}) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "GET",
    url: `${process.env.REACT_APP_NUTRITION_API_URL}/recipe/search${query}`,
  };
};

export const getUserWeeklyTarget = (
  queryObj: {
    [key: string]: any;
  },
  userId: string | undefined
) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "GET",
    url: `${process.env.REACT_APP_NUTRITION_API_URL}/weekly-targets${query}`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getAllRecipeList = (data: { [key: string]: any }) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_NUTRITION_API_URL}/recipe/fulltext/search`,
    data,
  };
};

export const getUnitOptions = (unitName: string) => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_NUTRITION_API_URL}/unit/${unitName}`,
  };
};

export const getRegionalStaples = (queryObj: { [key: string]: any }) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "GET",
    url: `${process.env.REACT_APP_NUTRITION_API_URL}/recipe/staples${query}`,
  };
};
